import React, { useContext, useEffect, useState } from "react";
import Radio from "components/common/radio";
import SectionDivider from "@components/common/divider";
import { Context } from "@components/useContext/context";
import { useDispatch, useSelector } from "react-redux";
import { Flex } from "@acko-tech/building-blocks.ui.common";
import { Wrapper } from "./styles";
import { setPayloadData } from "@store/slices/globalState";
import { setAnalytics } from "@actions/setAnalyticsData";
import { useOnload } from "@utils/useOnLoad";
import { CommonProps } from "@utils/interface";
import { setPayload } from "@actions/setPayloadData";
import { getWidgetSpecificProp } from "@utils/index";
import { connect } from "react-redux";

const mapStateToProps = function (state: any, ownProps: any) {
  return {
    is_visible: getWidgetSpecificProp(
      state.configuration?.normalisedConfig,
      ownProps.id,
      "is_visible"
    ),
    payloadData: getWidgetSpecificProp(
      state.configuration?.normalisedConfig,
      ownProps.id,
      "payloadData"
    )
  };
};
interface RadioSelectProps extends CommonProps {
  nomineeList?: string[];
  disabled?: boolean;
}

const RadioSelect = ({
  nomineeList = [],
  disabled,
  styles,
  payloadData,
  actions
}: RadioSelectProps) => {
  const dispatch = useDispatch();
  const { isDesktop } = useContext(Context);
  const { on_load, on_click } = actions || {};
  useOnload({ on_load });

  const { name, value } = payloadData;

  const [selected, setSelected] = useState<string | null>(value ?? null);

  const { globalPayload, fieldErrorData } = useSelector(
    ({ globalState }: any) => {
      return {
        globalPayload: globalState?.payloadData,
        fieldErrorData: globalState?.fieldErrorData
      };
    }
  );

  useEffect(() => {
    if (selected) {
      setSelected(selected);
      setPayload({
        payloadData: {
          [payloadData?.name]: selected
        }
      });
    }
  }, [selected]);

  const handleSelect = (selectedValue: string) => {
    if (disabled || !name) return;
    setSelected(selectedValue); 
    dispatch(setPayloadData({ [name]: selectedValue })); 
    setAnalytics({ [name]: selectedValue });

    (on_click || []).forEach((action) => {
      if (typeof action.funCall === "function") {
        action.funCall({
          data: { [name]: selectedValue },
          payloadData: { [name]: selectedValue },
          update_props: {
            payloadData: { name, value: selectedValue }
          },
          ...action.args
        });
      }
    });
  };

  return (
    <Wrapper style={styles}>
      {nomineeList.map((item, idx) => {
        const isLastTwo = idx >= nomineeList.length - 2;
        const isSelected = selected === item;
        return (
          <Flex
            key={idx}
            flexDirection="column"
            onClick={() => handleSelect(item)}
            style={isLastTwo ? { padding: "16px 0" } : {}}
          >
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              {item}
              <Radio isSelected={isSelected} size={isDesktop ? 20 : 16} />
            </div>
            {!isLastTwo && (
              <SectionDivider styles={{ borderTop: "1px solid #e0e0e8" }} />
            )}
          </Flex>
        );
      })}
    </Wrapper>
  );
};

export default connect(mapStateToProps)(RadioSelect);
